import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  // HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {finalize} from 'rxjs/operators';

import {GetPoomsaTxt, hunBody, hunChar} from '../../defines/gukeo.func';
import {Word} from '../../models/word.model';
import {BookmarkChange, LinkInfo, LIST_TYPE} from '../../defines/client.const';
import {PROVERB_COUNT_WORD_DETAIL} from "../../defines/desktop.const";
import {WordService} from '../../services/word/word.service';
import {OptionService} from '../../services/option/option.service';
import {VoiceService} from '../../services/voice/voice.service';
import {WordBookmarkService} from '../../services/word/word-bookmark.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";


@Component({
  selector: 'app-word-detail',
  templateUrl: './word-detail.component.html',
  styleUrls: ['./word-detail.component.scss']
})
export class WordDetailComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'page-contents scroll-effect over-y';
  @Output() bookmarkChange = new EventEmitter<BookmarkChange>;
  @ViewChild('wordOption') set wordOption(ref: ElementRef<HTMLElement> | undefined) {
    const nextEl = ref?.nativeElement;
    if (this.wordOptionEl === nextEl) {
      return;
    }
    this.wordOptionEl = nextEl;
    this.observeWordOptionResize();
    if (nextEl) {
      this.scheduleWordOptionReservedWidthUpdate();
    }
  }

  @Input() fromHomonym = false; // 이운이의어 화면에서 불려졌는지?
  @Input() autoPlay = false;  // 소리 자동 재생, option에도 있지만, 여기서도 중복 체크한다.
  @Input() showLevel = true;
  @Input() set word_id( value: string | null ) {
    // console.warn('WordDetailComponent::set word_id', value);
    if (value !== this._wordId) {
      // console.warn('WordDetailComponent::set wordId = ', value, this.elementRef, this.elementRef.nativeElement.offsetTop);
      this._wordId = value;
      this.elementRef.nativeElement.scrollTop = 0;
      this.word = null;
      this.showExampleLongVowels = true;

      if (this._wordId) {
        this.load$ = this.wordSvc.GetDetail(this._wordId).pipe(
          finalize(() => this.load$ = null),
        ).subscribe(
          data => {
            console.log(data);
            this.word = data;

            if (this.option.autoPlay && this.autoPlay) {
              this.PlayWord();
            }
          },
          err => console.error(err)
        );
      }
    }
  }

  protected readonly LIST_TYPE = LIST_TYPE;
  protected readonly PROVERB_COUNT_WORD_DETAIL = PROVERB_COUNT_WORD_DETAIL;
  protected readonly GetPoomsaTxt = GetPoomsaTxt;
  protected readonly hunBody = hunBody;
  protected readonly hunChar = hunChar;

  public _wordId: string | null = null;
  public word: Word | null = null;
  public showExampleLongVowels = true;
  public wordOptionReservedWidth = 0;
  private sendingBookmark = false;


  private load$: Subscription | null = null;
  private playWord$: Subscription | null = null;
  private wordOptionEl?: HTMLElement;
  private wordOptionWidthTimerId: ReturnType<typeof setTimeout> | null = null;
  private wordOptionResizeObserver: ResizeObserver | null = null;
  private isDestroyed = false;

  protected get IsLoading(): boolean {
    return this.load$ !== null;
  }


  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    private wordSvc: WordService,
    private option: OptionService,
    private voice: VoiceService,
    private bmSvc: WordBookmarkService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngOnInit(): void {
    // console.log('WordDetailComponent word=', this.word);

  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.clearWordOptionWidthTimer();
    this.disconnectWordOptionResizeObserver();
    if (this.playWord$) {
      this.playWord$.unsubscribe();
      this.playWord$ = null;
    }
    if (this.load$) {
      this.load$.unsubscribe();
      this.load$ = null;
    }
  }

  private scheduleWordOptionReservedWidthUpdate(): void {
    this.clearWordOptionWidthTimer();
    this.wordOptionWidthTimerId = setTimeout(() => {
      this.wordOptionWidthTimerId = null;
      this.updateWordOptionReservedWidth();
    });
  }

  private clearWordOptionWidthTimer(): void {
    if (this.wordOptionWidthTimerId !== null) {
      clearTimeout(this.wordOptionWidthTimerId);
      this.wordOptionWidthTimerId = null;
    }
  }

  private observeWordOptionResize(): void {
    this.disconnectWordOptionResizeObserver();
    if (!this.wordOptionEl || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.wordOptionResizeObserver = new ResizeObserver(() => {
      this.scheduleWordOptionReservedWidthUpdate();
    });
    this.wordOptionResizeObserver.observe(this.wordOptionEl);
  }

  private disconnectWordOptionResizeObserver(): void {
    if (this.wordOptionResizeObserver) {
      this.wordOptionResizeObserver.disconnect();
      this.wordOptionResizeObserver = null;
    }
  }

  private updateWordOptionReservedWidth(): void {
    if (this.isDestroyed) {
      return;
    }

    const width = this.wordOptionEl?.offsetWidth ?? 0;
    if (this.wordOptionReservedWidth === width) {
      return;
    }

    this.wordOptionReservedWidth = width;
    this.cdr.detectChanges();
  }

  // @HostListener('scroll', ['$event'])
  // onScroll(event: Event): void {
  //   console.warn('WordDetailComponent::onScroll', event);
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.globalEventSvc.Click(event, true);
  // }

  public PlayWord(): void {
    // console.warn('WordDetailComponent::PlayWord', this.word, this);

    if (this.word && this.word.hasVoice) {
      this.playWord$ = this.voice.PlayWord(this.word).pipe(
        finalize(() => this.playWord$ = null)
      ).subscribe();
    }
  }

  public ToggleBookmark(event: MouseEvent, word: Word): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (this.sendingBookmark) {
      return; // 이미 보내고 있다.
    }
    this.sendingBookmark = true;
    word.bookmark = !word.bookmark;
    this.bmSvc.sendBookmark(word.id, word.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => {
        console.log(data);
        this.bookmarkChange.emit({id: word.id, bookmark: word.bookmark});
      },
      err => console.error(err)
    );
  }

  public ToggleExampleLongVowels(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    this.showExampleLongVowels = !this.showExampleLongVowels;
  }

  public getBmCss(word: Word): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return word.bookmark ? 'on' : '';
  }

}
